export { default } from './AutoSizer';
export { default as AutoSizer } from './AutoSizer';


//////////////////
// WEBPACK FOOTER
// ./~/react-virtualized/dist/es/AutoSizer/index.js
// module id = 1052
// module chunks = 4